var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        {
          attrs: { opened: _vm.panelOpen },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "p-2" }, [
                    _c(
                      "div",
                      { staticClass: "bg-white rounded p-3 mb-2 mx-0" },
                      [
                        _c("addendum-history", {
                          attrs: {
                            history: _vm.data.addendumHistory,
                            status: _vm.data.status
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-5 col-xl-3 my-2 border-right d-flex flex-column justify-content-center align-items-start",
                staticStyle: { padding: "0 40px" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "badge badge-pill mb-2 font-14",
                    class: [`badge-${_vm.sufixType}`]
                  },
                  [_vm._v(" " + _vm._s(_vm.data.name) + " ")]
                ),
                _c("div", { staticClass: "color-secondary-6 font-14" }, [
                  _vm._v("Número de Aviso:")
                ]),
                _c(
                  "div",
                  { staticClass: "font-weight-normal color-black font-14" },
                  [_c("b", [_vm._v(_vm._s(_vm.data.code))])]
                )
              ]
            ),
            _c("div", { staticClass: "col-sm-8 col-xl-8" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Titulo: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-bold color-black font-14" },
                [_vm._v(" " + _vm._s(_vm.data.description) + " ")]
              ),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-md-6 col-xl-3" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Fecha de Publicación: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-bold color-black font-14" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm._f("date")(_vm.data.publishDate)) + " "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "col-md-6 col-xl-3" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Fecha de Comienzo: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-bold color-black font-14" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm._f("date")(_vm.data.startDate)) + " "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "col-md-6 col-xl-2" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Fecha de Presubasta: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-bold color-black font-14" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("date")(_vm.data.preAuctionDate)) +
                          " "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "col-md-6 col-xl-2" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Fecha de Finalización: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-bold color-black font-14" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm._f("date")(_vm.data.finishDate)) + " "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "col-md-6 col-xl-2" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Estatus: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-normal color-black font-14" },
                    [
                      _c("balloon", {
                        attrs: {
                          bg: `border-none text-center bg-${_vm.getStatusColor(
                            _vm.data.status.id
                          )}`,
                          dot: "",
                          text: _vm.data.status.name
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-md-12 col-xl-1 text-right d-flex justify-content-end pr-4 align-items-center"
              },
              [
                _vm.isDraft
                  ? _c("action-button", {
                      attrs: { i: "fas fa-edit", variant: "outline-success" },
                      on: { click: () => this.onEditHandler() }
                    })
                  : _vm._e(),
                !_vm.isDraft
                  ? _c("action-button", {
                      attrs: {
                        i: "fas fa-history",
                        variant: "outline-success"
                      },
                      on: { click: () => this.onHistoryHandler() }
                    })
                  : _vm._e(),
                !_vm.isDraft
                  ? _c("action-button", {
                      staticClass: "ml-3",
                      attrs: { i: "far fa-file-export", variant: "success" },
                      on: { click: () => this.onEditHandler() }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }